import React, { Component } from "react";
import { connect } from "react-redux";
import {
  get_jobseeker_profile,
  updateJobseekerConsent,
} from "../../../actions/jobseekerAction";
import {
  clearConsentSession,
  markConsentCompletedThisSession,
  requiresConsent,
} from "../../../consentUtils";
import store from "../../../store";

class ConsentPage extends Component {
  state = {
    submitting: false,
    error: "",
  };

  componentDidMount() {
    document.title = "Consent Required";
    store.dispatch(get_jobseeker_profile());
  }

  componentDidUpdate(prevProps) {
    const previousProfile = prevProps.JobseekerReducer.Profile;
    const currentProfile = this.props.JobseekerReducer.Profile;

    if (
      previousProfile !== currentProfile &&
      currentProfile &&
      !Array.isArray(currentProfile) &&
      !requiresConsent(currentProfile) &&
      !this.state.submitting
    ) {
      this.redirectToMyAccount();
    }
  }

  getLocalizedPath = (path) => {
    const lang = this.props.params && this.props.params.lang;
    return lang ? `/${lang}/${path}` : `/${path}`;
  };

  redirectToMyAccount = () => {
    this.props.router.replace(this.getLocalizedPath("myaccount"));
  };

  submitConsent = async (consent) => {
    const profile = this.props.JobseekerReducer.Profile;
    const userId =
      profile.user_id || this.props.actionReducer.Loginuser.id;

    if (!userId || this.state.submitting) return;

    this.setState({ submitting: true, error: "" });
    markConsentCompletedThisSession();
    const success = await store.dispatch(
      updateJobseekerConsent({
        user_id: userId,
        personal_info_sharing_consent: consent,
      })
    );

    if (success) {
      this.redirectToMyAccount();
      return;
    }

    clearConsentSession();
    this.setState({
      submitting: false,
      error: "Unable to save your consent. Please try again.",
    });
  };

  render() {
    const profile = this.props.JobseekerReducer.Profile || {};
    const userId =
      profile.user_id || this.props.actionReducer.Loginuser.id;
    const loadingProfile = !userId;

    return (
      <main className="container py-5" aria-labelledby="consent-page-title">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card shadow-sm border-0">
              <div className="card-body p-4 p-md-5">
                <h1 id="consent-page-title" className="h3 mb-3">
                  Consent Required
                </h1>

                {!loadingProfile && (
                  <>
                    <div className="text-left">
                      <p className="mb-4">
                        Your personal data is collected for the purpose of
                        providing employment-related services to you.
                      </p>
                      <p className="mb-4">
                        Please provide your consent by clicking "Yes" to allow
                        us to share your data with relevant stakeholders.
                      </p>
                      <p className="mb-4">
                        If you do not wish to share your personal data with
                        other stakeholders of the Employment Department,
                        please click "No".
                      </p>
                    </div>

                    {this.state.error && (
                      <div className="alert alert-danger" role="alert">
                        {this.state.error}
                      </div>
                    )}

                    <div className="d-flex justify-content-center gap-3">
                      <button
                        type="button"
                        className="btn btn-success px-4"
                        disabled={this.state.submitting}
                        onClick={() => this.submitConsent(1)}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger px-4"
                        disabled={this.state.submitting}
                        onClick={() => this.submitConsent(0)}
                      >
                        No
                      </button>
                    </div>
                  </>
                )}

                {loadingProfile && (
                  <p className="mb-0" role="status">
                    Loading your profile...
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(ConsentPage);
